import React from 'react';
import { motion } from 'framer-motion';
import { pains } from '../data/content';
export function PainPoints() {
  return <section className="w-full bg-white py-16 sm:py-24" aria-labelledby="pain-points-title" data-id="element-175" data-mp="2lm0tz9xrj6ti">
      <div className="mx-auto max-w-6xl px-6" data-id="element-176" data-mp="26xei5i7cgx71">
        <h2 id="pain-points-title" className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-tight tracking-tight text-navy-deep sm:text-4xl" data-id="element-177" data-mp="26wlewr7lgptn">
          What’s Happening In Your Cabinet Right Now — Whether You Know It Or Not.
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-178" data-mp="21x8ipfuu26ee">
          {pains.map((pain, index) => <motion.article key={pain.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          delay: index * 0.08,
          ease: 'easeOut'
        }} className="rounded-2xl border border-slate-200 bg-white p-7 shadow-sm" data-id="element-179" data-mp="1o1od1m447kox" data-mpi={index}>
              <span className="text-3xl" aria-hidden="true" data-id="element-180" data-mp="1yyu7pcytq1c7">
                {pain.emoji}
              </span>
              <h3 className="mt-4 text-lg font-bold leading-snug text-navy-deep" data-id="element-181" data-mp="1tzhjoow7uo81">{pain.title}</h3>
              <p className="mt-3 leading-relaxed text-ink/75" data-id="element-182" data-mp="27v32uffrqdsj">{pain.body}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}